// libs
import * as React from 'react'

// interfaces / constants
import { CLASS_PREFIX } from 'src/constants/'
import {
  DisplaySettings,
  mapDisplayModeToConst,
  POST_DISPLAY_MODE_DETAIL,
  PostDisplayMode,
  Purpose
} from 'src/interfaces/posts'

// components
import Icon from 'src/components/forms/icon/icon'
import NavigationItem from 'src/components/navigation_item/navigation_item'

// helpers
import DateFormatter, { ProcessableDate } from 'src/utils/date_formatter/date_formatter'

// styles
import './event_start_end.scss'

export const _classPrefix = `${CLASS_PREFIX}event-start-end__`

type EventStartEndSettings = { show: boolean };

const _settings: DisplaySettings<EventStartEndSettings> = {
  admin: {
    basic_ingredient: { show: true }
  },
  banner: {
    basic_ingredient: { show: false }
  },
  compact: {
    basic_ingredient: { show: false }
  },
  detail: {
    basic_ingredient: { show: true }
  },
  preview: {
    basic_ingredient: { show: false }
  }
}

export type Props = {
  data: {
    start: ProcessableDate;
    end?: ProcessableDate;
  };
  displayMode: PostDisplayMode;
  postDetailsURL?: string;
  purpose: Purpose;
};

export const EventStartEnd: React.FC<Props> = ({
  data: { end, start },
  displayMode,
  postDetailsURL,
  purpose
}) => {
  const cls = `${_classPrefix}${mapDisplayModeToConst[displayMode]}`
  const settings = _settings[displayMode][purpose]

  if (!settings?.show) {
    return null
  }

  const [firstLine, secondLine] = renderFormattedFromTo(
    displayMode !== POST_DISPLAY_MODE_DETAIL,
    start,
    end
  )
  return (
    <NavigationItem target="_self" url={postDetailsURL}>
      <div className={cls}>
        <div className={cls + '__column'}>
          <div className={cls + '__icon'}>
            <Icon aria-hidden="true" name={'calendar'} size={18} />
          </div>
        </div>
        <div className={cls + '__column'}>
          <p>{firstLine}</p>
          {secondLine ? <p>{secondLine}</p> : null}
        </div>
      </div>
    </NavigationItem>
  )
}

function renderFormattedFromTo (
  previewMode: boolean,
  startTime: ProcessableDate,
  endTime?: ProcessableDate
): string[] {
  if (previewMode) {
    return [DateFormatter.parseFrom(startTime)]
  }
  return DateFormatter.parseFromTo(startTime, endTime)
}
